import styled from "styled-components";
import Filters from "../Filters";
import FiltersButton from "../FiltersButton";
import MapButtons from "../MapButtons/index.js";
import {
  Legend as LegendComponent
} from "../Legend/styled.js";

export const AppFilters = styled(Filters)`
  position: absolute;
  z-index: 3;

  height: 100%;
  width: 100%;

  @media (min-width: 640px) {
    top: 0;
    bottom: 0;
    width: 310px;
  }
`;

export const MapFiltersButton = styled(FiltersButton)`
  display: none;

  @media (min-width: 640px) {
    display: flex;
    position: absolute;
    top: 70px;
    right: 20px;
    z-index: 2;
  }
`;

export const Legend = styled(LegendComponent)`
    bottom: 10px;
`;

export const StateMapButtons = styled(MapButtons)`
  bottom: 20px !important;

  @media (min-width: 640px) {
    bottom: 90px !important;
  }
`;
